// extracted by mini-css-extract-plugin
export default {"wordCloudEmptyState2":"empty-state_wordCloudEmptyState2__FKgip"};